import { Button, MuiAlert, strIsNullOrEmpty, Typography } from '@fox/atoms';
import { Flex, FlexColumnSpaced, FlexRow } from '@fox/layout';
import { useContentContext } from '../../content-context';
import { useVerifyImport } from '../query-hooks/query-implementations';
import { useImporterContext } from './importer-context';
import { redirect } from '../membership-form-template/util';

export function ImportOverview({ data }: { data: Record<string, unknown>[] }) {
	const { batchId, linkedOrganisationDetails, redirectUrl } = useImporterContext();
	const { contentId, requestToken } = useContentContext();

	const {
		data: verificationData,
		error,
		loading
	} = useVerifyImport({
		contentId,
		requestToken,
		id: batchId,
		numberOfRecordsImported: data.length,
		organisationId: linkedOrganisationDetails.organisationId,
		onFetchComplete: data => {
			if (!strIsNullOrEmpty(redirectUrl?.url) && data === true) {
				//give the system a little bit of time to create the invoice
				setTimeout(() => redirect(redirectUrl), 5000);
			}
		}
	});

	if (loading) {
		<MuiAlert severity="info">Verifying import...</MuiAlert>;
	}
	if (error) {
		<MuiAlert severity="error">{error}</MuiAlert>;
	}
	if (verificationData !== true && verificationData) {
		return <MuiAlert severity="error">Unable to verify import, please contact support</MuiAlert>;
	}

	return (
		<Flex style={{ justifyContent: 'center', paddingTop: '2rem' }}>
			<FlexColumnSpaced style={{ maxWidth: '40rem' }}>
				<MuiAlert>{`${data.length} records were successfully imported`}</MuiAlert>
				{strIsNullOrEmpty(redirectUrl?.url) ? (
					<>
						<Typography>
							If you would like to do another import, please click the button below. If not, you can now safely navigate away
							from this page.
						</Typography>
						<FlexRow style={{ justifyContent: 'center' }}>
							<Button
								onClick={() => {
									window.location.href = window.location.pathname + '?step=0';
								}}
								variant="primary"
								style={{ maxWidth: '10rem' }}
							>
								New Import
							</Button>
						</FlexRow>
					</>
				) : (
					<Typography>You will be redirected to see your invoice shortly.</Typography>
				)}
			</FlexColumnSpaced>
		</Flex>
	);
}
